import { handleError } from "../../utils/Common/Constant";
import apiClient from "../Connection/Connection";

// to get assessment types
export const getAssessmentTypes = async () => {
  try {
    return (await apiClient.get("assessmentType/getAssessmentTypes"))?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get Role Centric Render
export const getRoleCentricRender = async (component: string) => {
  try {
    return (
      await apiClient.get(
        `assessmentType/getRoleCentricRender?search=${component}`,
      )
    )?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get assessment skills
export const getIndustrySkill = async (
  industriesId: string,
  searchSkill: string,
  currentPage: number,
  pageSize: number,
) => {
  try {
    return (
      await apiClient.get(
        `industries/getIndustrySkillMapping?industriesId=${industriesId}&search=${searchSkill}&currentPage=${currentPage}&pageSize=${pageSize}`,
      )
    )?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get assessment existing template
export const getPublicAndCompaniesPrivateAssessment = async (
  industriesId: string,
  companyId: string,
  search: string,
  currentPage: number,
  pageSize: number,
) => {
  try {
    return (
      await apiClient.get(
        `assessment/getPublicAndCompaniesPrivateAssessment?industriesId=${industriesId}&companyId=${companyId}&search=${search}&currentPage=${currentPage}&pageSize=${pageSize}`,
      )
    )?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get assessment existing template
export const getAssessmentTemplate = async (
  search: string,
  currentPage: number,
  pageSize: number,
  hierarchyIds: string[],
  industryId: string,
) => {
  try {
    const hierarchyParam = JSON.stringify(hierarchyIds);
    const response = await apiClient.get(
      `/assessmentTemplate/getAssessmentTemplate?search=${search}&currentPage=${currentPage}&pageSize=${pageSize}&hierarchyIds=${encodeURIComponent(hierarchyParam)}&industryId=${industryId}`,
    );
    return response?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get system preference
export const getFrontEndSystemPreference = async () => {
  try {
    return (await apiClient.get("systemPreference/getSystemPreference"))?.data
      ?.data;
  } catch (error) {
    handleError(error);
  }
};

//  to delete assessment
export const deleteAssessment = async (
  assessmentId: string | number | null,
) => {
  try {
    const res = await apiClient.delete(
      `assessment/deleteDraftedAssessment?assessmentId=${assessmentId}`,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};

//  for update Assessment Status
export const updateAssessmentStatus = async (data: any) => {
  try {
    const res = await apiClient.put("assessment/updateAssessmentStatus", data);
    return res;
  } catch (error) {
    handleError(error);
  }
};

//  for reopen Deleted Assessment Status
export const reopenDeletedAssessment = async (data: any) => {
  try {
    const res = await apiClient.put("assessment/reopenDeletedAssessment", data);
    return res;
  } catch (error) {
    handleError(error);
  }
};

// company login
export const companyApplicant = async (data: any) => {
  try {
    const res = await apiClient.post("company/companyLogIn", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get category
export const getIndustrySkillMapping = async (
  categoryIds: any = [],
  search = "",
  currentPage: any,
  pageSize: any,
  filter: any = [],
  sortColumn?: any,
  sortOrder?: any,
) => {
  try {
    return (
      await apiClient.get(
        `industries/getIndustrySkillMapping?categoryIds=${JSON.stringify(categoryIds)}&search=${search}&currentPage=${currentPage}&pageSize=${pageSize}&filter=${JSON.stringify(filter)}${sortColumn ? `&sortColumn=${sortColumn}` : ""}${sortOrder ? `&sortOrder=${sortOrder}` : ""}`,
      )
    )?.data;
  } catch (error) {
    handleError(error);
  }
};
// to get default skill
export const getDefaultSkill = async (
  industriesId?: string,
  searchSkill?: string,
  currentPage?: number,
  pageSize?: number,
  filter: any = [],
  sortColumn?: any,
  sortOrder?: any,
) => {
  try {
    return (
      await apiClient.get(
        `industries/getIndustrySpecificSkill?industryId=${industriesId === "null" ? "" : industriesId}&search=${searchSkill}&currentPage=${currentPage}&pageSize=${pageSize}&filter=${JSON.stringify(filter)}${sortColumn ? `&sortColumn=${sortColumn}` : ""}${sortOrder ? `&sortOrder=${sortOrder}` : ""}`,
      )
    )?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

//get otp when signup
export const getOtp = async (data: any) => {
  try {
    const res = await apiClient.post("company/companyUserGetOtp", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// verify entered otp
export const verifyGetOtp = async (data: any) => {
  try {
    const res = await apiClient.post("company/companyUserVerifyOtp", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
//create password api
export const createPassword = async (data: any) => {
  try {
    const res = await apiClient.put(
      "company/GenerateCompanyUserPassword",
      data,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// signup with completed profile api
export const completeProfileApi = async (data: any) => {
  try {
    const res = await apiClient.post("company/completeProfile", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// validate api on getotp screen when client onboard by referral
export const validateReferredLink = async (
  partnerIdParam: any,
  emailParam: any,
) => {
  try {
    const res = await apiClient.get(
      `partner/validateReferredLink?q=${partnerIdParam}&e=${emailParam}`,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};

// Change password api
export const changePassword = async (data: any) => {
  try {
    const res = await apiClient.post("company/changePassword", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// get industries api
export const getIndustries = async (search: string) => {
  try {
    const res = await apiClient.get(
      `industries/getIndustries?search=${search}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get skill details
export const getSkillDetails = async (skillId: string) => {
  try {
    return (await apiClient.get(`skill/getSkill?skillId=${skillId}`))?.data
      ?.data;
  } catch (error) {
    handleError(error);
  }
};

//get reported text
export const getReportedQuestion = async (
  assessmentId: string,
  questionId: string,
) => {
  try {
    const res = await apiClient.get(
      `company/getReportedQuestion?assessmentId=${assessmentId}&questionId=${questionId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
//resend otp function
export const resendOtp = async (data: any) => {
  try {
    const res = await apiClient.post("company/companyUserResendOtp", {
      email: data,
      type: "Company",
    });
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
//update the result status
export const updateAssessmentApplicantResultStatus = async (data: any) => {
  try {
    const res = await apiClient.put(
      "company/updateAssessmentApplicantResultStatus",
      data,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};
//get all details of profile
export const getCompanyProfileDetails = async (companyUserId: any) => {
  try {
    const res = await apiClient.get(
      `company/companyProfileDetails?companyUserId=${companyUserId}`,
    );
    return res;
  } catch (error) {
    handleError(error);
    return error;
  }
};
//notify an applicatnt
export const notifyAnApplicant = async (data: any) => {
  try {
    const res = await apiClient.post("company/notifyAnApplicant", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
//get all questions reported by applicant
export const getReportedQuestionList = async (
  assessmentId: any,
  applicantId: any,
) => {
  try {
    const res = await apiClient.get(
      `company/companyGetReportedQuestionList?assessmentId=${assessmentId}&applicantId=${applicantId}`,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};
//  delete temp data
export const deleteAssessmentTempData = async (
  userId: string,
  tempAssessmentUId: string,
) => {
  try {
    const res = await apiClient.delete(
      `assessment/deleteAssessmentTempData?userId=${userId}&tempAssessmentUId=${tempAssessmentUId}`,
    );
    return res;
  } catch (error) {
    console.error(error);
  }
};

// to get payment package details
export const getCompanyPackageDetails = async (
  companyId: any,
  branchId: any,
) => {
  try {
    return (
      await apiClient.get(
        `package/getCompanyPackageDetails?companyId=${companyId}&branchId=${branchId}`,
      )
    )?.data?.data;
  } catch (error) {
    handleError(error);
  }
};

//getAllSupportTicketType
export const getAllSupportType = async () => {
  try {
    const res = await apiClient.get(
      "supportTicketType/getAllSupportTicketType",
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};
///supportTicket/createSupportTicket
export const createSupportTicket = async (data: any) => {
  try {
    const res = await apiClient.post("supportTicket/createSupportTicket", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// forgotpassword api
export const forgotpasswordApi = async (data: any) => {
  try {
    const res = await apiClient.post("company/forgotPassword", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

//validate token api when reset password
export const validateToken = async (token: any, type: any) => {
  try {
    const res = await apiClient.get(
      `company/validateResetToken?token=${token}&type=${type}`,
    );
    return res;
  } catch (error) {
    handleError(error);
  }
};

// company/resetPassword
export const resetPasswordApi = async (data: any) => {
  try {
    const res = await apiClient.post("company/resetPassword", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// to get GetAssessment Details By AssessementId
export const getAssessmentDetailsByAssessementId = async (
  assessmentId: string,
) => {
  try {
    return (
      await apiClient.get(
        `company/companyGetAssessmentDetailsByAssessementId?assessmentId=${assessmentId}`,
      )
    )?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getCountryList = async (search?: string) => {
  try {
    const res = await apiClient.get(
      `country/getCountryList?search=${search}&currentPage=1&pageSize=100`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getStateList = async (countryId: string, search?: string) => {
  try {
    const res = await apiClient.get(
      `/state/getStateList?countryId=${countryId}&search=${search}&currentPage=1&pageSize=100`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getJobDetails = async (jobCode?: any) => {
  try {
    const res = await apiClient.get(`/jobs/jobDetails?jobCode=${jobCode}`);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getSimilarJobs = async (
  jobCode: any,
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `/jobs/getSimilarJobs?jobCode=${jobCode}&currentPage=${currentPage}&pageSize=${pageSize}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const applyJob = async (data: any) => {
  try {
    const res = await apiClient.post("/jobs/applyJob", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getAddressFromLatLng = async (lat: any, lng: any) => {
  try {
    const res = await apiClient.get(
      `company/getAddressFromLatLng?lat=${lat}&lng=${lng}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

export const getSkillKeywords = async (
  skillId: string,
  difficultyLevel: string[],
  search?: string,
  pageSize?: any,
  currentPage?: any,
) => {
  try {
    const params = new URLSearchParams();
    params.append("skillId", skillId);
    params.append("difficultyLevel", JSON.stringify(difficultyLevel));
    if (search) {
      params.append("search", search?.trim());
    }
    params.append("pageSize", pageSize);
    params.append("currentPage", currentPage);
    const res = await apiClient.get(
      `skill/getSkillKeywords?${params.toString()}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
// get userInfo in likedinLogin
export const getLinkedInUserInfo = async (code: any) => {
  try {
    const res = await apiClient.get(
      `company/getLinkedInUserInfo?code=${code}&type=Company`,
    );
    return res;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const getSampleQuestion = async (data: any) => {
  try {
    const res = await apiClient.post("company/getSampleQuestion", {
      assessmentSkills: data,
    });
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// get scope hierarchy list
export const getScopeHierarchyList = async (industryId: any) => {
  try {
    const res = await apiClient.get(
      `assessmentTemplate/getHierarchyList?industryId=${industryId}`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// logout api
export const logoutApi = async (data: any) => {
  try {
    const res = await apiClient.post("/company/logout", data);
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};
